import { Link, useLocation } from "react-router-dom";
import classes from "../components/loggedout/LoggedOut.module.scss";
import { useForm } from "react-hook-form";
import { useTranslation, Trans } from 'react-i18next';
import { DDD, E2Data } from "../lib/ddd/ddd";
import { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import axios from "axios";
import ReactFlagsSelect from "react-flags-select";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import { create } from "@mui/material/styles/createTransitions";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PasswordStrengthBar from 'react-password-strength-bar';
import { OrgIdContext } from "../store/orgId_context";
import Cookies from 'js-cookie'
import LoadingDots from "../components/UI/LoadingDots";
import LanguageSelector from "../components/UI/LanguageSelector";
import { ThemeContext } from "../store/ThemeContext";
import { INPUT_MAX_LENGTH, USERNAME_MAX_LENGTH, sanitizeUsername, validateEmailFormat, validateUsernameFormat } from "../constants";
import dddLogo from "../assets/logo.svg";
import { useLoggedOutHeading } from "../store/LoggedOutHeaderContext";

//const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT ? process.env.REACT_APP_ORIGIN+"/"+window.location.pathname+"/json.rpc" : window.location.origin + window.location.pathname + "/json.rpc";
const tokenrefresh = process.env.REACT_APP_API_ENDPOINT ? process.env.REACT_APP_ORIGIN+ "/Auth/RefreshApiTokens" : window.location.origin + "/Auth/RefreshApiTokens";
// Turnstile is required for sign-up: the backend rejects AddUser with "Insufficient
// authorization" unless the Turnstile verification RPC has run first, so this can't stay
// disabled. Its "Failed CAPTCHA verification" error state used to add a line of height to
// the form, which (via the scale-to-fit card) visibly shrank the whole card's rendered
// width whenever it appeared — .turnstileSlot below reserves stable space for it (same
// treatment as .errorSlot for the general error message) so that can't recur.
const TURNSTILE_ENABLED = true;

const SignUpNew = () => {
    const {logo} = useContext(ThemeContext);
    const [selected, setSelected] = useState("SI");
    const [phone, setPhone] = useState();
    // The phone field's country follows the tax-number country (see onTaxCountrySelect),
    // so both start out on the same one.
    const [phoneCountry, setPhoneCountry] = useState("si");
    const [phoneTouched, setPhoneTouched] = useState(false);
    const [phoneError, setPhoneError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [candidateId, setCandidateId] = useState(null);
    const [mode, setMode] = useState("init");//init, confirm, finish, google, org, completedRedirecting
    const [identity, setIdentity] = useState();//erp, saas, company, enterprise
    const [role, setRole] = useState(); //Technician, Manager, Other
    const [identityError, setIdentityError] = useState(null);
    const [showPasswords, setShowPasswords] = useState(false);
    const {sessionInfo, setSessionInfoHandler} = useContext(OrgIdContext);
    // True once step 1 has created the account (or the Google return has): the session
    // then carries a real user. An anonymous session reports the all-zero id instead — the
    // same check App.js uses to tell a signed-in user without an organisation apart.
    const accountCreated = !!sessionInfo?.User?.Id && sessionInfo.User.Id !== "00000000-0000-0000-0000-000000000000";
    const [pass, setPass] = useState(null);
    const [gpass,setGpass] = useState(null);
    const [referCode, setReferCode] = useState(null);
    const [acceptedLegal, setAcceptedLegal] = useState(false);
    const { t, i18n } = useTranslation();
    useLoggedOutHeading(
        mode === "init" ? t("Start 30-day free access") :
        mode === "org" ? t("Register a business") :
        mode === "finish" ? "" : t("Sign Up")
    );
    const scoreWords = [t('weak'), t('weak'), t('okay'), t('good'), t('strong')];
    const location = useLocation();
    const [logindisabled, setLogindisabled] = useState(TURNSTILE_ENABLED);
    const [showTurnstile, setShowTurnstile] = useState(true);
    // The captcha now lives exactly as long as the box it's drawn into. It used to be a
    // one-shot effect guarded by an "already initialised" flag, which drew it into the first
    // box it saw and never again. But that box sits inside the step-1 form, which unmounts
    // whenever the page switches to step 2 — including on every refresh of a half-finished
    // sign-up, where the session sends the page straight to step 2. Coming back mounted a
    // fresh, empty box the flag refused to draw into: no captcha, so it could never be
    // passed, so Continue stayed disabled for good. A callback ref runs on every mount and
    // unmount of the box, so each mount gets its own widget and the old one is removed.
    const turnstileWidgetIdRef = useRef(null);
    const turnstileRef = useCallback((node) => {
        if (!TURNSTILE_ENABLED) return;
        if (node) {
            renderTurnstileInto(node);
        } else if (turnstileWidgetIdRef.current !== null) {
            if (window.turnstile) window.turnstile.remove(turnstileWidgetIdRef.current);
            turnstileWidgetIdRef.current = null;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Split-card layout shared with Login.jsx (see the SCSS comments on .loginSplit for
    // why this scales as one unit instead of resizing paddings per breakpoint).
    const pageRef = useRef(null);
    const splitRef = useRef(null);
    const stepperRef = useRef(null);
    const headingRef = useRef(null);
    const googleBtnRef = useRef(null);
    const orgSubmitBtnRef = useRef(null);
    const summaryContinueRef = useRef(null);
    const bottomGroupRef = useRef(null);
    const logoRowRef = useRef(null);
    const [infoRowTops, setInfoRowTops] = useState(null);

    // Pins the left panel's top group to the stepper's top (falling back to the heading
    // when the stepper isn't rendered, e.g. modes other than init/org), the tagline
    // ("You grow the business...") to land level with the "Start 30-day free access"
    // heading (same technique as Login's "Don't have an account?" ↔ "Email Address" pin —
    // a computed margin-top keeps the tagline a normal flow child so the description
    // paragraph below it still just follows via its own fixed gap), and aligns the
    // "Already have an account? / Log in" bottom group's bottom edge with whichever
    // right-panel button is the step's actual last action — the Google button in init
    // mode (Figma also shows this block on the org step, which has no Google button, so
    // it falls back to that step's own submit button instead) — since both are 60px
    // tall, this lands their tops flush too, matching the request to align them.
    useLayoutEffect(() => {
        const split = splitRef.current;
        if (!split) return;

        const updateInfoRowTops = () => {
            if ((window.innerWidth <= 767 || window.innerHeight <= 600)) {
                setInfoRowTops(null);
                return;
            }
            const anchor = stepperRef.current || headingRef.current;
            const heading = headingRef.current;
            const logoRow = logoRowRef.current;
            // init mode aligns to the Google button; org mode has no Google button (only
            // its own submit button), so that's the anchor there instead.
            // Step 1 shown read-only (account already created) has no Google button either;
            // its own Continue is that screen's last action.
            const lastActionBtn = mode === "org" ? orgSubmitBtnRef.current : (googleBtnRef.current || summaryContinueRef.current);
            const bottomGroup = bottomGroupRef.current;
            if (!anchor) return;

            let taglineMarginTop;
            if (logoRow && heading) {
                const logoBottom = anchor.offsetTop + logoRow.offsetTop + logoRow.offsetHeight;
                taglineMarginTop = heading.offsetTop - logoBottom;
            }

            let bottomGroupTop;
            if (lastActionBtn && bottomGroup) {
                bottomGroupTop = lastActionBtn.offsetTop + lastActionBtn.offsetHeight - bottomGroup.offsetHeight;
            }

            setInfoRowTops({
                groupTop: anchor.offsetTop,
                taglineMarginTop,
                bottomGroupTop,
            });
        };

        updateInfoRowTops();
        if (document.fonts?.ready) {
            document.fonts.ready.then(updateInfoRowTops);
        }
        const ro = new ResizeObserver(updateInfoRowTops);
        ro.observe(split);
        window.addEventListener('resize', updateInfoRowTops);
        return () => {
            ro.disconnect();
            window.removeEventListener('resize', updateInfoRowTops);
        };
    }, [mode]);
    useEffect(() => {
        const handleKey = (e)=>{
            switch(e.key){
                case 'F7':
                    setMode("init");
                    break;
                case 'F2':
                    setMode("org");
                    break;
                case 'F3':
                    setMode("finish");
                    break;
                case 'F4':
                    setMode("confirm");
                    break;
                case 'F5':
                    setMode("google");
                    break;
                case 'F6':
                    setMode("completedRedirecting");
                    break;
                    default:break;
            }
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    },[]);
    const {
        register,
        formState: { errors },
        handleSubmit,
        watch,
    } = useForm();
    const password = watch('password1');

    // The username is asked for separately from the e-mail (it used to be a copy of it)
    // because the backend validates the two by very different rules — see the notes in
    // constants.js. It's also normalised to lower case as it's typed: DDD.ChangePassword
    // salts with the lower-cased username while DDD.Login salts with whatever the user
    // typed at the login screen, so a username carrying any upper case would set a
    // password that login then can't reproduce.
    // Optional: left blank, the backend generates a username from the name and e-mail, so
    // the field only has to hold up to the format rules when something was actually typed.
    const usernameField = register("username", {
        validate: (value) => !(value || "").trim() || validateUsernameFormat(value, t),
    });

    const {
        register:register2,
        formState: { errors:errors2 },
        handleSubmit:handleSubmit2,
        watch:watch2,
    } = useForm();

    
    const _setError = (message) => {
        setError(message);
        setTimeout(() => {
            setError(null);
        }, 7000);
    }

    const translations = useCallback(() => {
        t('System.Exception. Username is already taken.');
        t('Insufficient authorization');
    }, []);

    useEffect(()=>{
        const val = getGoogleOAuth();
        if(val){
            setMode("google");
            registerGoogle(val);
        }
    },[]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const referCodeParam = params.get('refercode');
        if (referCodeParam) {
            setReferCode(referCodeParam);
        }
    }, [location]);

    const getGoogleOAuth = () => {
        const val = Cookies.get('oauth-signup-info');
        Cookies.remove('oauth-signup-info');
        if(val){
            try{
                const g = JSON.parse(val);
                setGpass(g);
                return g;
            }catch{
                return null;
            }
        }
        return null;
    }

    useEffect(() =>{
        axios.post(tokenrefresh+"?url="+window.location.pathname, {}).then(res =>{
            
        }).catch(err => {});
    },[]);

    const refreshToken = () =>{
        axios.post(tokenrefresh+"?url="+window.location.pathname, {}).then(res =>{}).catch(err => {});
    }

    useEffect(() => {
        if(sessionInfo && !sessionInfo.Organization){
            setMode("org");
        }
    }, [sessionInfo]);

    const registerGoogle = (val) => {
        // Google gives us an e-mail and no username, and this flow has no form to ask for
        // one — so the address is stripped down to what the backend accepts as a username
        // (see constants.js). When nothing usable is left, no username is sent at all and
        // the backend derives one itself from the name and e-mail.
        const username = sanitizeUsername(val.UserEmail);
        const userArgs ={
            info : {
                user : {
                    Email : val.UserEmail,
                    ...(username ? {UserName : username} : {}),
                    Name : val.UserFirstName || val.UserEmail,
                    LastName : val.UserLastName || val.UserEmail,
                    AuthProvider : "Google",
                    Culture: i18n.__culture||"en-US",
                    Domain: getMainDomain(),
                },
            },
            activate : true,
            session : true
        }
        console.log(userArgs);
        const ddd = new DDD(apiRequestAddress);
        ddd.AddUser(userArgs).then((response) => {
            if(response?.error){
                refreshToken();
                setLoading(false);
                setMode("init");
                return onCreateUserErrorResponse(response);
            }
            ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then((response) => {
                setLoading(false);
                if(response?.error){
                    return _setError(response.error.message||t("An error occurred while creating the user"));
                }
                setSessionInfoHandler(response.result);
                setMode("org");
            });
            
        });
    }

    const signupSubmitNew = (data) => {
        //return onCreateUserErrorResponse({error:{data:"During the holidays we are in process of moving ours services to a new data center. We will be back soon. Thank you for your understanding and happy holidays."}});
        if(data.password1 !== data.password2)
            return _setError(t("Passwords do not match"));
        if(data.password1.length < 8)
            return _setError(t("Password must be at least 8 characters long"));

        // Never a copy of the e-mail: the backend rejects anything outside its username
        // character set with "Illegal characters detected in input or input too long.",
        // which any address using the "user+tag@gmail.com" form (the usual way of creating
        // test accounts) would always trip. Optional, though — left empty, no UserName is
        // sent at all and the backend derives one from the name and e-mail by its own
        // rules, which is the behaviour it's designed for.
        const username = (data.username || "").trim().toLowerCase();

        const userArgs ={
            info : {
                user : {
                    Email : data.email,
                    ...(username ? {UserName : username} : {}),
                    Name : data.name,
                    LastName : data.lastname,
                    Domain: getMainDomain(),
                    Culture: i18n.__culture||"en-US",
                },
            },
            activate : true,
            session : true,
            sendMailVerificationEmail: true
        }
        setLoading(true);
        const ddd = new DDD(apiRequestAddress);

        const setPasswordAndContinue = (loginUsername) => {
            ddd.ChangePassword(loginUsername, data.password1, data.password2).then((response) => {
                if(response?.error){
                    setLoading(false);
                    return _setError(response.error.message||t("An error occurred while creating the user"));
                }
                ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then((response) => {
                    setLoading(false);
                    if(response?.error){
                        return _setError(response.error.message||t("An error occurred while creating the user"));
                    }
                    setPass(data);
                    setSessionInfoHandler(response.result);
                    setMode("org");
                });
            });
        };

        ddd.AddUser(userArgs).then((response) => {
            if(response?.error){
                refreshToken();
                setLoading(false);
                return onCreateUserErrorResponse(response);
            }

            if(username)
                return setPasswordAndContinue(username);

            // Auth.ChangePassword identifies the account by username, so when the backend
            // was left to generate one it has to be read back before the password can be
            // set — AddUser opened a session (session: true), and that session knows it.
            ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then((sessionResponse) => {
                const generatedUsername = sessionResponse?.result?.User?.PrimaryUsername;
                if(!generatedUsername){
                    setLoading(false);
                    return _setError(sessionResponse?.error?.message||t("An error occurred while creating the user"));
                }
                setPasswordAndContinue(generatedUsername);
            });
        });
    }

    const onCreateUserErrorResponse = (response) => {
        // Used to read "This email is already registered" back when the username was just a
        // copy of the e-mail; now that they're separate fields the backend means the
        // username field specifically.
        if(response?.error?.data?.indexOf("Username is already taken") > -1)
            return _setError(t("This username is already taken"));
        if(typeof response?.error?.data === "string")
            return _setError(response?.error?.data);
        return _setError(t(response.error.message)||t("An error occurred while creating the user"));
    }

    const onGoogleClick = () => {
        //window.location.href = "oauth/google?signupHandlerUrl=" + encodeURIComponent(oauthSignUpHandlerUrl) + "&signinHandlerUrl=" + encodeURIComponent(oauthSignInHandlerUrl);
        window.location.href = "@oauth/google?signupHandlerUrl=dashboard-sign-up&signinHandlerUrl=dashboard";
    }
    
    const signupSubmit = (data) => {
        const _data ={
            Culture : navigator.language || navigator.userLanguage,
            SignUpType : "Username",
        }
        _data.AdminEmail = data.email;
        _data.AdminLastname = data.lastName;
        _data.AdminName = data.firstName;
        _data.AdminPersonRole = data.role;
        _data.CountryCode = selected;
        _data.TaxNum = data.taxNumber;
        _data.Name = data.businessName;
        _data.Telephone = phone;
        _data.Source = "SimpleSignup";


        setLoading(true);
        let counter=0;
        let errored = false;
        if(candidateId){
            const e2data2 = new E2Data("OrganisationsReg_Candidates");
            e2data2.values = _data;
            e2data2.filter = "Id='"+candidateId+"'";
            e2data2.Modify().then((response) => {
                setLoading(false);
            });

            return;
        }
        const e2data2 = new E2Data("OrganisationsReg_Candidates");
        e2data2.filter = "TaxNum='"+_data.TaxNum+"' AND Registered<>null AND FromDomain='dddinvoices.com'";
        e2data2.GetData().then((response) => {
            setLoading(false);
            if(response?.result?.count > 0)
                return _setError(t("This tax number is already registered"));
            createCandidate(_data);
            /* const e2data1 = new E2Data("OrganisationsReg_Candidates");
            e2data1.filter = "Registered=null AND ForRegistration<>true AND TaxNum='"+_data.TaxNum+"' AND SignUpType='Username' AND FromDomain='dddinvoices.com'";
            e2data1.GetData().then((response) => {
                counter++;
                if(response?.result?.count>0){
                    _setError(t("This tax number waiting to be registered"));
                    errored = true;
                }
    
                if(counter >1){
                    setLoading(false);
                    if(!errored) createCandidate(_data);
                } 
            });
            
    
            const e2data3 = new E2Data("OrganisationsReg_Candidates");
            e2data3.filter = "Registered=null AND ForRegistration<>true AND AdminEmail='"+_data.AdminEmail+"' AND SignUpType='Username' AND FromDomain='dddinvoices.com'";
            e2data3.GetData().then((response) => {
                counter++;
                if(response?.result?.count>0){
                    _setError(t("This email is already waiting to be registered"));
                    errored = true;
                }
                if(counter >1){
                    setLoading(false);
                    if(!errored) createCandidate(_data);
                } 
            }); */
        });
    };

    const userExists = async (email, filterAppend="") => {
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.filter = "SignUpType='Username' AND FromDomain='dddinvoices.com' AND AdminEmail='"+email+filterAppend;
        const response = await e2data.GetData();
        return response?.result?.count>0;
    }

    const taxExists = async (tax, filterAppend="") => {
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.filter = "SignUpType='Username' AND FromDomain='dddinvoices.com' AND TaxNum='"+tax+filterAppend;
        const response = await e2data.GetData();
        return response?.result?.count>0;
    }

    const getMainDomain = () => {
        //return sessionInfo?.BaseUrl;
        if(sessionInfo?.BaseUrl){
            const url = new URL(sessionInfo?.BaseUrl);
            return url.hostname; // Extracts the hostname
        }else{
            return window.location.hostname;
            /*var parts = window.location.hostname.split('.');
            if (parts.length === 1) {
                // Handle "localhost"
                return window.location.hostname;
            } else {
                // Return the last two parts of the hostname
                return parts.slice(-2).join('.');
            }*/
        }
    };

    // Once step 1 has run, the new account stays signed in, and App.js sends any signed-in
    // user without an organisation straight back to this page — so without signing out
    // first there is no way to begin a sign-up for a different account. The account left
    // behind isn't lost: logging in with it later lands back on step 2.
    const startOver = () => {
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteMethod("Auth.SignOut", {}).finally(() => {
            window.location.href = "@dashboard-sign-up";
        });
    };

    // A company's owner almost always has a phone number from the same country the company
    // is registered in, so picking the tax-number country also sets the phone field's
    // country — but only until the user has touched the phone field themselves.
    // react-phone-input-2 applies a changed `country` prop by overwriting the field with
    // that country's bare dial code (its updateCountry), so following any later would wipe
    // a number they'd already typed, or undo a country they'd picked on purpose.
    const onTaxCountrySelect = (code) => {
        setSelected(code);
        if (phoneTouched) return;
        setPhoneCountry(code.toLowerCase());
        // updateCountry changes what the field shows without firing onChange, so `phone`
        // has to be cleared here or it would keep the previous country's dial code.
        setPhone('');
    };

    const signupComplete = (data) => {
        identity ? setIdentityError(null) : setIdentityError("Please select your identity")
        phone ?  setPhoneError(null) : setPhoneError("Please enter your phone number")
        if(!identity || !phone) return;

        if(!sessionInfo?.User?.Id)
            return _setError(t("An error occured while connecting to user session"));

        const _data ={
            Culture : navigator.language || navigator.userLanguage,
            SignUpType : "Username",
        }
        _data.MyAccessAsAdmin = true;
        _data.AdminUserId = sessionInfo?.User?.Id;
        _data.AdminPersonRole = data.role;
        _data.CountryCode = selected;
        _data.TaxNum = data.taxNumber;
        _data.Name = data.businessName;
        _data.Telephone = phone.startsWith('+') ? phone : '+' + phone;
        _data.ForRegistration = true;
        if(referCode)
            _data.PromoCode = referCode;
        applyClientType(_data, identity);

        const ddd = new DDD(apiRequestAddress);
        setLoading(true);
        ddd.Rpc_ExecuteExtension("EUeInvoices.SignUpRegisterOrg", {data : _data}).then(res => {
            //setLoading(false);
            if(res?.result.Status === "OK"){
                setMode("completedRedirecting");
                ddd.InvalidateSessionExtensions().then(res2 => {
                    ddd.ChangeOrganization(res.result.Result.Id).then(res =>{
                        window.location.href = "@/dashboard";
                    });
                    /*ddd.Rpc_ExecuteMethod("Auth.SignOut", {}).then(res => {
                        if(pass){
                            const ddd2 = new DDD(apiRequestAddress, pass.email, pass.password1);
                            ddd2.Login(pass.emai, pass.password1).then((response) => {
                                setLoading(false);
                                window.location = "@/dashboard";
                            }).catch((error) => {
                                setLoading(false);
                                _setError(t("Invalid login credentials"));
                            });
                        }else if(gpass){
                            
                        }else{
                            setLoading(false);
                            //we can't login. Need to redirect him to login page
                            window.location.href = "@/dashboard";
                        }
                    });*/
                });
            }else{
                setLoading(false);
                if(res?.result?.Reason?.indexOf("Company already exists") > -1)
                    return _setError(t("This company is already registered"));
                _setError(t("An error occurred while creating the organisation. Please contact administrator"));
            }
        });
    };

    const createCandidate = (_data) => {
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.values=_data;
        e2data.Create().then((response) => {
            if(response?.result?.affected !== 1)
                return _setError(t("An error occurred while creating the candidate"));

            setCandidateId(response?.result?.values[0].id);
            setMode("confirm");
        });
    }

    const applyClientType = (data, identity) => {
        switch(identity){
            case "erp":
                data["ClientType"] = "ISV";
                data["isIntegrator"] = false;
                data["isTransformer"] = true;
                break;
            case "saas":
                data["ClientType"] = "Builder";
                data["isIntegrator"] = false;
                data["isTransformer"] = true;
                break;
            case "company":
                data["ClientType"] = "Company";
                data["isIntegrator"] = false;
                data["isTransformer"] = true;
                break;
            case "enterprise":
                data["ClientType"] = "Enterprise";
                data["isIntegrator"] = false;
                data["isTransformer"] = true;
                break;
                default:break;
        }
    }

    const finishCreation = () =>{
        const e2data = new E2Data("OrganisationsReg_Candidates");
        e2data.filter = "Id='"+candidateId+"'";
        e2data.values = {ForRegistration : true,}

        //erp, saas, company
        switch(identity){
            case "erp":
                e2data.values["ClientType"] = "ISV";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
            case "saas":
                e2data.values["ClientType"] = "Builder";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
            case "company":
                e2data.values["ClientType"] = "Company";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
            case "enterprise":
                e2data.values["ClientType"] = "Enterprise";
                e2data.values["isIntegrator"] = false;
                e2data.values["isTransformer"] = true;
                break;
                default:
                    break;
        }
        setLoading(true);
        e2data.Modify().then((response) => {
            setLoading(false);
            if(response?.result?.affected !== 1)
                return _setError(t("An error occurred while finishing the registration"));
            setMode("finish");
        });
    }
    /*const options = [
        { value: 'erp', label: t('An ISV/Software Provider/Platform that has developed a software with an invoicing feature and we need to provide compliant invoicing for our SME users or want to add an invoicing feature to our software'), sublabel: t("(Financial or management softwares, ERP/CRM providers, acc & invoicing apps, payment processors, SaaS with invoicing etc.)") },
        { value: 'saas', label: t("I am building a SaaS invoicing solution and want to significantly shorten my development cycle.") },
        { value: 'company', label: t("An Individual Software Company and we want to solve our own invoicing/billing to charge our users") },
        { value: 'enterprise', label: t("A SME that is using a 3rd party ERP/invoicing/acc. software (Sage, SAP, Xero, 1C, ...) and need to issue/receive compliant invoices from/to it"), sublabel: t("(you probably have an integration partner for the software you are using)")  },
    ];*/
    const options = [
        { value: 'erp', shortLabel: t("Software provider, platform or ISV"), label: t("I am a software provider/platform/ISV and want to solve my client’s invoicing"), sublabel: t("(ERPs, CRMs, accounting/invoicing apps, payment providers, SaaS etc.)"), tooltipTitle: t("ISV (Software provider)"), tooltipText: t("Your customers will issue or receive invoices through your software.") },
        { value: 'company', shortLabel: t("End-client"), label: t("I am an SME company and want to solve own invoicing/billing"), sublabel: t("(I use ERP, billing platform, invoicing app, SaaS etc.)"), tooltipTitle: t("End-client (Business user)"), tooltipText: t("Your company will issue or receive own invoices.") },
        /* { value: 'enterprise', label: t("An SME that has an integration partner for a 3rd party software (SAP, Sage, 1C, Xero etc.)") }, */
        /* { value: 'saas', label: t("I am building a SaaS invoicing solution and want to shorten my dev. cycle with your e-invoicing library."), sublabel: t("(you probably have an integration partner for the software you are using)")  }, */
    ];

    const roleOptions = [
        { value: 'Manager', label: t("CEO, Product owner or Business") },
        { value: 'Technician', label: t("Developer, CTO or Technical") },
        { value: 'Other', label: t("Other") },
    ]

    // Draws a captcha into `node`. The Turnstile script is loaded with `defer`, so on a slow
    // connection it can still be missing when the box first mounts — retry briefly rather
    // than leave the box empty, since an empty box means Continue can never be enabled.
    const renderTurnstileInto = (node, attempt = 0) => {
        if (!node.isConnected) return;
        if (!window.turnstile) {
            if (attempt < 20) setTimeout(() => renderTurnstileInto(node, attempt + 1), 250);
            return;
        }
        turnstileWidgetIdRef.current = window.turnstile.render(node, {
            sitekey: "0x4AAAAAABBlj-20RQ9Ma24E",
            callback: function (token) {
                _setShowTurnstile(true);
                setLogindisabled(true);
                verifyToken(token);
            },
            "error-callback": function (error) {
                setLogindisabled(true);
                _setError(t("Failed CAPTCHA verification"));
            },
            "expire-callback": () => {
                _setShowTurnstile(true);
            },
        });
    };
    
    const verifyToken = async (token) => {
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.TurnstileVerification", {"Token": token}).then(res => {
            if(res?.result?.success === true){
                setLogindisabled(false);
                _setShowTurnstile(false);
                return;
            } 
            _setError(t("Failed CAPTCHA verification"));
        })

    }

    const _setShowTurnstile = (val) =>{
        if(val) setShowTurnstile(true);
        if(!val) setTimeout(() => setShowTurnstile(false), 2000);
    }

    return (<>
    <div className={classes.page} ref={pageRef}>
    <div className={classes.loginScaleWrapper}>
    <div className={`${classes.loginSplit} ${classes.loginSplitTall}`} ref={splitRef}>
        {!logo && <div className={classes.loginInfoPanel}>
            <div className={classes.loginInfoTopGroup} style={infoRowTops ? {top: infoRowTops.groupTop} : undefined}>
                <div className={classes.loginInfoLogo} ref={logoRowRef}>
                    <img src={dddLogo} alt="" />
                    <span>DDD Invoices</span>
                </div>
                <div className={`${classes.loginInfoNoAccount} ${classes.signupInfoTagline}`} style={infoRowTops?.taglineMarginTop !== undefined ? {marginTop: infoRowTops.taglineMarginTop} : undefined}>
                    {t("You grow the business. We handle invoice compliance.")}
                </div>
                <div className={`${classes.loginInfoBody} ${classes.signupInfoDescription}`}>
                    <p>{t("Start with 30 days of free access to a unified platform for e-invoicing, fiscalization, archiving, VAT reporting and invoice monitoring - without compliance holding your business back.")}</p>
                </div>
            </div>
            {/* Figma shows this "Already have an account? / Log in" block on the org step
                too (step 2), not just init (step 1) — was mode==="init" only. */}
            {(mode === "init" || mode === "org") && <div className={classes.loginInfoTopGroup} ref={bottomGroupRef} style={infoRowTops?.bottomGroupTop !== undefined ? {top: infoRowTops.bottomGroupTop} : undefined}>
                <div className={classes.loginInfoNoAccount}><span className={classes.loginInfoNoAccountText}>{t("Already have an account?")}</span></div>
                {/* Step 1 (and step 2, if org submission already created the account) leaves
                    an active session behind for the partial/in-progress signup — App.js's
                    session-loaded handler auto-redirects any authenticated user with no
                    Organization yet straight back to this same signup flow. Left alone,
                    clicking "Log in" here just bounced the user right back to wherever they
                    were instead of actually reaching the login form, since that stale
                    session was still valid the moment /login loaded. Signing out first
                    clears it, so the redirect has nothing to trigger on and the user lands
                    on a real, empty login page. */}
                <button type="button" className={classes.signupInfoBtn} onClick={() => {
                    const ddd = new DDD(apiRequestAddress);
                    ddd.Rpc_ExecuteMethod("Auth.SignOut", {}).finally(() => {
                        window.location.href = "@login";
                    });
                }}>{t("Log in")}</button>
            </div>}
        </div>}
        <div className={classes.loginFormPanel}>
            <div className={classes.loginFlagWrap} style={{display:"flex", alignItems:"center"}}>
                <LanguageSelector imgWidth="16"/>
            </div>
            {(mode === "init" || mode ==="org") &&
                <div className={classes.signupStepper} ref={stepperRef}>
                    <div className={classes.signupStepperTabs}>
                        <span className={mode==="init" ? classes.signupStepperTabActive : classes.signupStepperTab}>{t("Create account")}</span>
                        <span className={mode==="org" ? classes.signupStepperTabActive : classes.signupStepperTab}>{t("Complete registration")}</span>
                    </div>
                    <div className={classes.signupProgressTrack}>
                        <div className={classes.signupProgressFill} style={{width: mode==="org" ? "100%" : "60%"}}></div>
                    </div>
                </div>
            }
            {mode !== "finish" &&
                <h1 className={classes.loginHeading} ref={headingRef}>
                    {mode === "init" && t("Start 30-day free access")}
                    {mode === "org" && t("Register a business")}
                    {mode !== "init" && mode !== "org" && t("Sign Up")}
                </h1>
            }
            {/* Reached via "Back to account creation" on step 2. Step 1 isn't a draft:
                its Continue created the account, set the password and signed the user in,
                so showing the form again and letting Continue re-run it asked the server to
                create the same account a second time — which it refuses ("Invalid
                credentials."), leaving the user unable to get back to step 2 at all. Once
                the account exists this shows it read-only instead, and Continue just
                returns to step 2 without contacting the server. Read from the session
                rather than the step-1 form so it also works for Google sign-ups, which
                never filled that form in. */}
            {mode==="init" && accountCreated && <div className={classes.signupCreatedSummary}>
                <p className={classes.signupCreatedNote}>{t("Your account has already been created.")}</p>
                <label>{t("Full name")}</label>
                <input className={`${classes.loginInput} ${classes.signupFieldLocked}`} readOnly tabIndex={-1} value={sessionInfo?.User?.Name || ""}/>
                <label>{t("Work e-mail")}</label>
                <input className={`${classes.loginInput} ${classes.signupFieldLocked}`} readOnly tabIndex={-1} value={sessionInfo?.User?.Email || ""}/>
                <label>{t("Username")}</label>
                <input className={`${classes.loginInput} ${classes.signupFieldLocked}`} readOnly tabIndex={-1} value={sessionInfo?.User?.PrimaryUsername || ""}/>
                <button type="button" ref={summaryContinueRef} className={classes.loginSubmitBtn} onClick={() => setMode("org")}>{t("Continue")}</button>
                <button type="button" className={classes.signupBackBtn} onClick={startOver}>{t("Start over with a different account")}</button>
            </div>}
            {mode==="init" && !accountCreated && <>
                <form onSubmit={handleSubmit(signupSubmitNew)}>
                <div className={classes.signupNameRow}>
                    <div className={classes.signupNameField}>
                        <label>{t("First name")}</label>
                        <input className={classes.loginInput} name="name" placeholder={t("First name")} maxLength={INPUT_MAX_LENGTH} {...register("name", {required: t("This field is required")})}/>
                        {errors["name"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors["name"].message}</div>}
                    </div>
                    <div className={classes.signupNameField}>
                        <label>{t("Last name")}</label>
                        <input className={classes.loginInput} name="lastname" placeholder={t("Last name")} maxLength={INPUT_MAX_LENGTH} {...register("lastname", {required: t("This field is required")})}/>
                        {errors["lastname"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors["lastname"].message}</div>}
                    </div>
                </div>
                <label>{t("Work e-mail")}</label>
                <input className={classes.loginInput} name="email" placeholder="name@address.com" type="email" maxLength={INPUT_MAX_LENGTH} {...register("email", {
                    required: t("This field is required"),
                    validate: (value) => validateEmailFormat(value, t),
                })}/>
                {errors["email"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors["email"].message}</div>}
                <label>{t("Username (optional)")}</label>
                <input
                    className={classes.loginInput}
                    name="username"
                    placeholder={t("Leave empty and we'll create one for you")}
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck="false"
                    maxLength={USERNAME_MAX_LENGTH}
                    {...usernameField}
                    onChange={(e) => {
                        e.target.value = e.target.value.toLowerCase();
                        usernameField.onChange(e);
                    }}
                />
                {errors["username"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors["username"].message}</div>}
                <label>{t("Create a password")}</label>
                <div className={classes.loginPasswordWrap}>
                    <input
                        key={"password1"}
                        className={classes.loginInput}
                        placeholder={t("Must be 8 characters")}
                        type={showPasswords ? "text" : "password"}
                        maxLength={INPUT_MAX_LENGTH}
                        {...register("password1", {required: t("This field is required")})}
                    />
                    <span onClick={() => setShowPasswords(val => !val)} className={classes.loginPasswordIcon}>
                        {!showPasswords && <VisibilityIcon style={{fontSize:"1.1rem"}}/>}
                        {showPasswords && <VisibilityOffIcon style={{fontSize:"1.1rem"}}/>}
                    </span>
                </div>
                {errors["password1"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors["password1"].message}</div>}
                <label>{t("Confirm password")}</label>
                <div className={classes.loginPasswordWrap}>
                    <input
                        key={"password2"}
                        className={classes.loginInput}
                        placeholder={t("Repeat password")}
                        maxLength={INPUT_MAX_LENGTH}
                        type={showPasswords ? "text" : "password"}
                        {...register("password2", {required: t("This field is required")})}
                    />
                    <span onClick={() => setShowPasswords(val => !val)} className={classes.loginPasswordIcon}>
                        {!showPasswords && <VisibilityIcon style={{fontSize:"1.1rem"}}/>}
                        {showPasswords && <VisibilityOffIcon style={{fontSize:"1.1rem"}}/>}
                    </span>
                </div>
                {errors["password2"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors["password2"].message}</div>}
                <div className={classes.signupPasswordStrength}>
                    <PasswordStrengthBar password={password} minLength={8} scoreWords={scoreWords} shortScoreWord={t("too short")}/>
                </div>
                <div className={classes.errorSlot}>
                    {error && <div style={{color: "rgb(232, 73, 14)"}}>{error}</div>}
                </div>
                <div className={classes.signupLegalRow}>
                    <label className={classes.signupLegalLabel}>
                        <input
                        type="checkbox"
                        checked={acceptedLegal}
                        onChange={(e) => setAcceptedLegal(e.target.checked)}
                        />
                        <span>
                        <Trans
                            /* The key is the English sentence itself, as everywhere else in
                               this project (useKeysAsDefaultValue). It used to be the short
                               name "legalConsentText" with the sentence in `defaults` — but
                               i18next-parser writes every English key's value as the key, so
                               extraction stored "legalConsentText": "legalConsentText", and a
                               stored value always beats `defaults`. English then rendered the
                               bare key next to the checkbox. */
                            i18nKey="You hereby state that you have read and agree with the <0>DDD Invoices Terms of Service</0> and the <1>Data Processing Agreement</1> that describes how DDD Invoices d.o.o. conducts its data processing activities when providing the DDD Invoices service to you as a data processor."
                            t={t}
                            components={[
                                <a href="https://dddinvoices.com/terms-and-conditions" target="_blank" rel="noopener noreferrer" key="0"/>,
                                <a href="https://dddinvoices.com/privacy-policy" target="_blank" rel="noopener noreferrer" key="1"/>,
                            ]}
                        />
                        </span>
                    </label>
                </div>
                {TURNSTILE_ENABLED && (
                    <div className={classes.turnstileSlot}>
                        {showTurnstile && <div className="cf-turnstile" ref={turnstileRef} data-theme="light"></div>}
                    </div>
                )}
                {loading && <LoadingDots/>}
                {!loading && <button type="submit" className={classes.loginSubmitBtn} disabled={loading||logindisabled||!acceptedLegal}>{t("Continue")}</button>}
            </form>
            {/* Was `{!loading && <>...}` (fully unmounting this section during the submit
                API call) — but the "Already have an account? / Log in" block's on-screen
                position is computed in JS by anchoring to googleBtnRef's position (see the
                useLayoutEffect above). Unmounting it nulled that ref mid-calculation, so
                the Log-in button briefly snapped to a wrong fallback position right when
                Continue was clicked. Kept mounted and just visually hidden instead, so the
                ref (and the position it drives) stays stable through the loading state. */}
            <div style={{visibility: loading ? "hidden" : "visible"}}>
                <div className={classes["line-through"]}>
                    <span className={classes["line-text"]}>{t("or register with")}</span>
                </div>
                <div onClick={onGoogleClick} className={classes.loginGoogleBtn} ref={googleBtnRef}>
                    <svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3429_249)">
                        <path d="M18.6749 9.71009C18.6749 8.93122 18.6131 8.36285 18.4792 7.77344H9.77344V11.2889H14.8835C14.7805 12.1625 14.2242 13.4782 12.9878 14.3623L12.9705 14.48L15.7231 16.6585L15.9138 16.6779C17.6652 15.0254 18.6749 12.594 18.6749 9.71009Z" fill="#4285F4"/>
                        <path d="M9.77165 18.9724C12.2752 18.9724 14.3769 18.1303 15.912 16.6778L12.9861 14.3622C12.2031 14.9201 11.1522 15.3095 9.77165 15.3095C7.31963 15.3095 5.23851 13.6571 4.49664 11.373L4.3879 11.3825L1.52571 13.6454L1.48828 13.7517C3.01306 16.8462 6.14508 18.9724 9.77165 18.9724Z" fill="#34A853"/>
                        <path d="M4.4974 11.3731C4.30165 10.7837 4.18836 10.1521 4.18836 9.49955C4.18836 8.84693 4.30165 8.21543 4.4871 7.62602L4.48191 7.50049L1.58385 5.20117L1.48903 5.24725C0.860597 6.53136 0.5 7.97337 0.5 9.49955C0.5 11.0257 0.860597 12.4677 1.48903 13.7518L4.4974 11.3731Z" fill="#FBBC05"/>
                        <path d="M9.77165 3.69016C11.5128 3.69016 12.6873 4.45851 13.357 5.1006L15.9738 2.49029C14.3667 0.964108 12.2752 0.0273438 9.77165 0.0273438C6.14508 0.0273438 3.01306 2.15346 1.48828 5.2479L4.48635 7.62667C5.23851 5.34267 7.31963 3.69016 9.77165 3.69016Z" fill="#EB4335"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_3429_249">
                        <rect x="0.5" width="18.1739" height="19" rx="9.08696" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <div>{t("Google")}</div>
                </div>
            </div>
            </>}

            {mode === "org" && <>
                <form onSubmit={handleSubmit2(signupComplete)}>
                    <label>{t("Business")}</label>
                    <input className={`${classes.loginInput} ${classes.loginInputFixed}`} name="businessName" placeholder={t("Legal name of your business")} maxLength={INPUT_MAX_LENGTH} {...register2("businessName", {required: t("This field is required")})}/>
                    {errors2["businessName"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors2["businessName"].message}</div>}

                    <label>{t("Type of business")}</label>
                    <div className={classes.signupOptionList}>
                        {options.map(opt => (
                            <div
                                key={opt.value}
                                className={`${classes.signupOptionCard} ${identity === opt.value ? classes.signupOptionCardActive : ''}`}
                                onClick={() => setIdentity(opt.value)}
                            >
                                {/* The description is permanent text, not a tooltip behind an
                                    ⓘ. This choice decides how the account is set up and
                                    cannot be undone by the user, and people were completing
                                    registration with the wrong one — a tooltip is the worst
                                    place for that, since on a phone it takes a deliberate
                                    tap, so exactly the people about to choose wrongly never
                                    read it. Shown here instead of as a confirmation step
                                    afterwards, so the explanation arrives while the choice
                                    is being made rather than once it has been. */}
                                <span className={classes.signupOptionCardText}>
                                    <span className={classes.signupOptionCardLabel}>{opt.shortLabel}</span>
                                    <span className={classes.signupOptionCardDescription}>{opt.tooltipText}</span>
                                </span>
                                <span className={classes.signupRadioDot}/>
                            </div>
                        ))}
                    </div>
                    <div className={classes.signupOptionNote}>{t("This determines how your account is set up. To change it later you would have to contact us.")}</div>
                    {identityError && <div style={{color: "rgb(232, 73, 14)"}}>{identityError}</div>}

                    <label>{t("Country and tax number")}</label>
                    <div className={classes.signupJoinedField}>
                        <ReactFlagsSelect
                            selected={selected}
                            onSelect={onTaxCountrySelect}
                            className={classes.signupCountrySelect}
                            searchable
                            searchPlaceholder={t("Search countries")}
                            showSelectedLabel={true}
                            showSecondarySelectedLabel={false}
                            selectedSize={20}
                            optionsSize={16}
                            fullWidth={false}
                            selectButtonClassName={classes.signupCountryButton}
                        />
                        <input className={classes.signupJoinedFieldInput} maxLength={INPUT_MAX_LENGTH} name="taxNumber" placeholder={t("Tax number of the business")} {...register2("taxNumber", {required: t("This field is required")})} />
                    </div>
                    {errors2["taxNumber"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors2["taxNumber"].message}</div>}

                    <label>{t("Role")}</label>
                    <div className={classes.signupOptionList}>
                        {roleOptions.map(opt => (
                            <div
                                key={opt.value}
                                className={`${classes.signupOptionCard} ${role === opt.value ? classes.signupOptionCardActive : ''}`}
                                onClick={() => setRole(opt.value)}
                            >
                                <span className={classes.signupOptionCardLabel}>{opt.label}</span>
                                <span className={classes.signupRadioDot}/>
                            </div>
                        ))}
                    </div>
                    {errors2["role"] && <div style={{color: "rgb(232, 73, 14)"}}>{errors2["role"].message}</div>}

                    <label>{t("Phone number")}</label>
                    <PhoneInput
                        country={phoneCountry}
                        value={phone}
                        onChange={(val, countryData) => {
                            setPhone(val);
                            // Digits typed past the dial code, or another country picked
                            // from the phone field's own dropdown: from here on the user
                            // owns this field and the tax country stops steering it.
                            if (val.length > (countryData?.dialCode || '').length || countryData?.countryCode !== phoneCountry)
                                setPhoneTouched(true);
                        }}
                        specialLabel={null}
                        inputStyle={{border:"1px solid #E7E7E7", borderRadius:"10px", fontFamily:"Poppins", fontSize:"20px", color:"#00274F", width:"100%", height:"58px", paddingLeft:"58px"}}
                        buttonStyle={{border:"1px solid #E7E7E7", borderRight:"none", borderRadius:"10px 0 0 10px", background:"#fff", height:"58px"}}
                        />
                    {phoneError && <div style={{color: "rgb(232, 73, 14)"}}>{phoneError}</div>}
                    <div className={classes.errorSlot}>
                        {error && <div style={{color: "rgb(232, 73, 14)"}}>{error}</div>}
                    </div>
                    {loading && <LoadingDots/>}
                    {/* Kept mounted (visibility, not unmounted) for the same reason as the
                        Google button above — orgSubmitBtnRef drives the "Already have an
                        account? / Log in" block's position on this step too. */}
                    <button type="submit" ref={orgSubmitBtnRef} className={classes.loginSubmitBtn} disabled={loading} style={loading ? {visibility: "hidden"} : undefined}>{t("Complete the registration")}</button>
                    {/* Figma: outlined button directly below the submit button, returning
                        to step 1 without losing whatever was already filled in there
                        (mode alone gates which fields render — react-hook-form's own state
                        for the step-1 form isn't reset by this). */}
                    <button type="button" className={classes.signupBackBtn} disabled={loading} onClick={() => setMode("init")}>{t("Back to account creation")}</button>
                </form>
            </>}

            {mode === "google" && <>
                <div className={classes["line-through"]}>
                    <span className={classes["line-text"]}>{t("Please wait...")}</span>
                </div>
                <LoadingDots/>
            </>}

            {mode === "confirm" && <>
                <label>{t("What do you idenfity with the most?")}*</label>
                <div onClick={() => setIdentity("erp")} className={`${classes["large-select"]} ${identity!=="erp" ? classes["large-select-unselected"] : ""}`} style={{display:"flex"}}>
                    <div>
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M20.6002 26.9638C21.2245 26.0013 21.8501 24.7638 22.2997 23.1756C23.3379 23.5744 24.0501 24.0501 24.4874 24.4255C23.3672 25.5381 22.0255 26.4024 20.5494 26.9624H20.6002V26.9638ZM8.50025 24.4131C8.96225 24.0377 9.66212 23.5744 10.7002 23.1619C11.1622 24.7624 11.7631 25.9999 12.3997 26.9624C10.9455 26.3903 9.62596 25.5222 8.525 24.4131H8.50025ZM23.1248 15.2501C23.0862 14.1364 22.9735 13.024 22.7879 11.9254C24.1629 11.4249 25.1625 10.8254 25.8624 10.2754C26.8383 11.7693 27.4427 13.475 27.6251 15.2501H23.1248ZM10.7869 9.47512C10.0593 9.20705 9.37359 8.83666 8.7505 8.37512C9.80432 7.36732 11.0436 6.57349 12.3997 6.03762C11.8126 6.91212 11.2379 8.03687 10.7745 9.47512H10.7882H10.7869ZM20.6002 6.03762C21.9573 6.57176 23.1969 7.36579 24.2495 8.37512C23.6257 8.8355 22.9402 9.2058 22.2131 9.47512C21.8405 8.25672 21.293 7.09883 20.5879 6.03762H20.6002ZM20.35 12.5373C20.4737 13.3623 20.6002 14.2505 20.625 15.2501H12.375C12.4121 14.2505 12.4987 13.3499 12.6252 12.5373C15.1759 12.9965 17.787 12.9965 20.3376 12.5373H20.35ZM16.5 10.3744C15.2487 10.3744 14.1487 10.2754 13.2137 10.1255C14.212 7.04962 15.763 5.81212 16.5 5.37487C17.2122 5.81212 18.7756 7.062 19.7752 10.1255C18.6918 10.2952 17.5966 10.3784 16.5 10.3744ZM7.12525 10.2754C8.05993 10.986 9.10198 11.543 10.2121 11.9254C10.0266 13.025 9.91402 14.1357 9.87525 15.2501H5.324C5.52142 13.4706 6.14341 11.7645 7.13762 10.2754H7.12525ZM5.33775 17.7499H9.87525C9.92475 18.8251 9.999 19.8124 10.1502 20.713C8.9986 21.1086 7.92402 21.7003 6.974 22.462C6.07493 21.0362 5.51079 19.4251 5.324 17.7499H5.33775ZM16.5 19.7505C15.0012 19.7505 13.7129 19.8743 12.5881 20.075C12.4782 19.3045 12.4071 18.5289 12.375 17.7512H20.625C20.5879 18.5872 20.5246 19.3738 20.4256 20.075C19.1304 19.8409 17.8162 19.7281 16.5 19.7381V19.7505ZM16.5 27.6251C15.7506 27.1755 14.1006 25.8376 13.0996 22.5005C14.2235 22.3173 15.3614 22.2336 16.5 22.2502C17.8131 22.2502 18.9379 22.3369 19.9127 22.5005C18.9131 25.8748 17.2631 27.1755 16.5124 27.6251H16.5ZM26.0246 22.4496C25.0758 21.6869 24.0015 21.0951 22.8497 20.7006C23.0004 19.7234 23.0923 18.7381 23.1248 17.7499H27.676C27.4874 19.4208 26.9219 21.0275 26.0246 22.4496ZM16.5 2.75C8.90587 2.75 2.75 8.90588 2.75 16.5C2.75 24.0941 8.90587 30.25 16.5 30.25C24.0941 30.25 30.25 24.0941 30.25 16.5C30.25 8.90588 24.0941 2.75 16.5 2.75Z" fill="#b0b0b0"></path>
                        </svg>
                    </div>
                    <div className="text-start">{t("I am a SaaS / ERP / accounting software vendor that wants to enable e-invoicing for users (API connection).")}</div>
                </div>
                <div onClick={() => setIdentity("saas")} className={`${classes["large-select"]} ${identity!=="saas" ? classes["large-select-unselected"] : ""}`} style={{display:"flex"}}>
                    <div>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 1.02148C30 0.457064 29.5159 0 28.9197 0H18V4.11587C18.2709 3.97292 18.5828 3.89189 18.9145 3.89189C19.9556 3.89189 20.8001 4.69029 20.8001 5.67583C20.8001 6.66043 19.9561 7.45927 18.9145 7.45927C18.5828 7.45927 18.2709 7.37779 18 7.2358V11.3512H22.3509C22.2004 11.6075 22.1142 11.9024 22.1142 12.2161C22.1142 13.2015 22.9582 14 24 14C25.0413 14 25.8853 13.2015 25.8853 12.2161C25.8853 11.9024 25.7992 11.6075 25.6491 11.3512H30V1.02148Z" fill="#b0b0b0"></path>
                            <path d="M25.4566 16.0361H19.9581C19.7656 16.0361 19.5874 16.1379 19.49 16.303L19.4953 16.2939L19.489 16.304C19.4393 16.3885 19.4142 16.484 19.4142 16.5791C19.4142 16.6699 19.4374 16.7615 19.4827 16.8437L19.8293 17.4677C19.907 17.6082 19.9451 17.7559 19.9456 17.9171C19.9452 18.1661 19.8496 18.3958 19.6739 18.5725C19.4973 18.7482 19.2671 18.8438 19.0184 18.8447C18.7694 18.8437 18.5392 18.7482 18.362 18.5725L18.3627 18.5735C18.1865 18.3959 18.0912 18.1657 18.0907 17.9171C18.0912 17.7564 18.1293 17.6082 18.2068 17.4673L18.5536 16.8437C18.5992 16.7616 18.6221 16.6705 18.6221 16.5792C18.6221 16.4841 18.597 16.3886 18.5465 16.3031C18.4488 16.1376 18.2707 16.0362 18.0784 16.0362H13.9643V13.8329C14.7078 13.8213 15.4101 13.5283 15.9361 13.0012C16.4748 12.464 16.7731 11.7434 16.7726 10.9823C16.773 10.2202 16.4745 9.49959 15.9361 8.96286C15.4105 8.43573 14.708 8.14325 13.9643 8.1317V4.54348C13.964 4.2433 13.7207 4 13.4206 4H2.04712C1.50174 3.99959 0.984096 4.21338 0.599417 4.599C0.217405 4.98131 0.000474819 5.50595 7.84883e-07 6.04748V27.9531C-0.000473249 28.498 0.21379 29.0154 0.599417 29.4005C0.981725 29.7823 1.50559 29.9995 2.04712 30H23.955C24.4951 29.9995 25.0192 29.7823 25.401 29.4005C25.7867 29.0154 26.0005 28.4984 26 27.9531V16.5796C26.0001 16.2794 25.7568 16.0361 25.4566 16.0361ZM1.68104 6.04748C1.68104 5.92198 1.73947 5.83659 1.78723 5.78878C1.83671 5.73954 1.92185 5.68064 2.04712 5.68064H12.2831V10.0419C12.2831 10.1472 12.3389 10.2442 12.4294 10.2977C12.4757 10.3248 12.5275 10.3383 12.5797 10.3383C12.6294 10.3383 12.6789 10.3263 12.7238 10.3012L13.3476 9.95461C13.5235 9.85707 13.7152 9.80736 13.9169 9.80736C14.2304 9.80736 14.5255 9.92948 14.7473 10.151C14.9693 10.3735 15.0915 10.6689 15.0915 10.9822C15.0915 11.2954 14.9693 11.5904 14.7478 11.8124C14.5255 12.0344 14.2304 12.1565 13.9169 12.1565C13.7149 12.1565 13.5235 12.1068 13.3479 12.0093L12.7235 11.6627C12.6789 11.6376 12.6292 11.6255 12.5797 11.6255C12.5276 11.6255 12.4757 11.639 12.4294 11.6666C12.3389 11.7197 12.2832 11.8167 12.2832 11.9219V16.2832H9.58266C9.58799 16.2161 9.5906 16.1491 9.5906 16.0829C9.5906 15.3855 9.3191 14.7305 8.82657 14.2387C8.33453 13.7459 7.67953 13.4747 6.98211 13.4747C6.28492 13.4747 5.62998 13.7459 5.13812 14.2382C4.64512 14.73 4.37362 15.3855 4.37385 16.0825C4.37385 16.1491 4.37646 16.2157 4.38179 16.2833H1.68104V6.04748ZM12.2832 28.3194H2.04712C1.92185 28.3194 1.8367 28.2605 1.78841 28.2127C1.73947 28.1635 1.68104 28.078 1.68104 27.9531V17.7163H6.0421C6.1471 17.7163 6.24433 17.6608 6.29766 17.5705C6.35099 17.4798 6.35247 17.3678 6.30134 17.2761L5.95505 16.652C5.85728 16.4758 5.80781 16.2842 5.80757 16.0829C5.80781 15.7697 5.93023 15.4743 6.15124 15.2523C6.37392 15.0308 6.66913 14.9081 6.98211 14.9081C7.29509 14.9081 7.59029 15.0308 7.81226 15.2518C8.03405 15.4743 8.15641 15.7697 8.15665 16.0824C8.15641 16.2846 8.10664 16.4763 8.00987 16.6515L7.66282 17.2756C7.61163 17.3678 7.61317 17.4798 7.66649 17.57C7.71982 17.6607 7.81712 17.7162 7.92206 17.7162H12.2831V20.4177C12.216 20.4124 12.1492 20.41 12.0831 20.41C11.3854 20.41 10.7304 20.6812 10.2391 21.1735C9.74584 21.6658 9.47458 22.3208 9.47505 23.0177C9.47458 23.7147 9.74585 24.3702 10.2387 24.862C10.7305 25.3548 11.3855 25.626 12.0831 25.626C12.1497 25.626 12.2166 25.6236 12.2832 25.6183V28.3194ZM24.3194 27.9531C24.3194 28.078 24.2605 28.163 24.2122 28.2118C24.163 28.2605 24.078 28.3194 23.9531 28.3194H13.7171V23.9581C13.7171 23.8529 13.6617 23.7559 13.5709 23.7028C13.5245 23.6752 13.4726 23.6618 13.4206 23.6618C13.3711 23.6618 13.3214 23.6739 13.2767 23.6989L12.6519 24.0455C12.4765 24.143 12.2851 24.1927 12.0831 24.1927C11.7701 24.1927 11.4749 24.0702 11.2529 23.849C11.0311 23.627 10.9088 23.3316 10.9085 23.0183C10.9088 22.7046 11.0312 22.4097 11.2527 22.1877C11.4745 21.9662 11.7696 21.8436 12.0831 21.8431C12.2837 21.8431 12.4753 21.8928 12.652 21.9903L13.2765 22.3373C13.3214 22.3624 13.3708 22.3745 13.4206 22.3745C13.4727 22.3745 13.5246 22.361 13.5709 22.334C13.6614 22.2804 13.7172 22.1834 13.7172 22.0781V17.7164H16.4179C16.4126 17.7834 16.4099 17.8506 16.4099 17.9171C16.4097 18.6136 16.681 19.2686 17.1735 19.7609C17.6658 20.2542 18.321 20.5254 19.0182 20.5254C19.7154 20.5254 20.3704 20.2542 20.8627 19.7614C21.3555 19.2696 21.6263 18.6146 21.6263 17.9172C21.6263 17.8506 21.6238 17.784 21.6186 17.7164H24.3195V27.9531H24.3194Z" fill="#b0b0b0"></path>
                        </svg>
                    </div>
                    <div className="text-start">{t("I am building a SaaS invoicing solution and want to significantly shorten my development cycle.")}</div>
                </div>
                <div onClick={() => setIdentity("company")} className={`${classes["large-select"]} ${identity!=="company" ? classes["large-select-unselected"] : ""}`} style={{display:"flex"}}>
                    <div>
                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.7 26H24.3C25.785 26 27 24.7916 27 23.3146V7.01432C27 5.53736 25.785 4.32894 24.3 4.32894H20.052V2.28804C19.944 0.9364 18.765 -0.0840466 17.406 0.00546626H9.594C8.235 -0.0840466 7.056 0.9364 6.948 2.28804V4.32894H2.7C1.215 4.32894 0 5.53736 0 7.01432V23.3146C0 24.7916 1.215 26 2.7 26ZM8.748 2.28804C8.748 2.06426 9.117 1.79572 9.594 1.79572H17.406C17.883 1.79572 18.252 2.06426 18.252 2.28804V4.32894H8.748V2.28804ZM1.8 16.4311H5.04V15.5986C5.04 15.1063 5.445 14.7035 5.94 14.7035H9.297C9.792 14.7035 10.197 15.1063 10.197 15.5986V16.4311H16.803V15.5986C16.803 15.1063 17.208 14.7035 17.703 14.7035H21.06C21.555 14.7035 21.96 15.1063 21.96 15.5986V16.4311H25.2V18.2213H21.96V18.4183C21.96 19.8326 20.808 20.9873 19.386 20.9873C17.964 20.9873 16.803 19.8415 16.803 18.4272V18.2303H10.197V18.4272C10.197 19.8415 9.045 20.9962 7.623 20.9962C6.201 20.9962 5.04 19.8326 5.04 18.4183V18.2213H1.8V16.4311Z" fill="#435288"></path>
                        </svg>
                    </div>
                    <div className="text-start">{t("I am a company that has to comply with the e-invoicing regulations and / or wants to connect to an e-invoicing network.")}</div>
                </div>
                <button onClick={finishCreation} className={`${classes.btn}`} disabled={loading}>{t("Submit")}</button>
            </>}
            {mode === "holiday" && <>
                <h2>{t("Happy holidays")}</h2>
                <p className="mt-2">{t("During the holidays we are in process of moving ours services to a new data center. We will be back soon. Thank you for your understanding and happy holidays.")}</p>

                <span><Link onClick={() => window.location = "@"} className={classes["main-blue-link"]}>{t("Back to homepage")}</Link></span>
            </>}
            {mode === "finish" && <>
                <h2>{t("Thank you for registering!")}</h2>
                <p className="mt-2">{t("We will get back to you shortly via email.")}</p>

                <span><Link onClick={() => window.location = "@"} className={classes["main-blue-link"]}>{t("Back to homepage")}</Link></span>
            </>}
            {mode ==="completedRedirecting" && <>
                <h2>{t("Thank you for registering!")}</h2>
                <p className="mt-2">{t("You will be redirected shortly")}...</p>
                <span><Link onClick={() => window.location = "@dashboard"} className={classes["main-blue-link"]}>{t("Or click here to continue")}</Link></span>
            </>}
        </div>
    </div>
    </div>
    <div className={classes.footerText}>
      Please note: Any other data you offer to us directly (either through the fields above or
      elsewhere) that we might need in order to do business with you (e.g. register your account,
      communicate with you, issue invoices, etc.) we may process as a “data controller”
      (see our <a href="https://dddinvoices.com/privacy-policy" className={classes.legalLink}>Privacy Policy</a> to learn more).
      <br />
      The personal data you provide will be processed by DDD Invoices d.o.o. for the purpose of
      providing and offering our services. Where permitted by applicable law and based on relevant
      legal exceptions for electronic communications, we may also send you commercial e-mails if you
      are our existing customer, until you opt out of such communications. You can find more
      information about how we process your personal data in our
      <a href="https://dddinvoices.com/privacy-policy" className={classes.legalLink}> Privacy Policy</a>.
    </div>
    </div>

    </>);
};

export default SignUpNew;